import { Injectable } from '@angular/core';
import { flatten } from 'ramda';
import { isNotNil } from '@gelato-api-ui/utils/ramda';
import { PriceNavigatorDraftPrices } from '@api-ui-app/src/app/price-navigator/prices/types/price-navigator.types';
import { EProductVariantUpdateRequest } from '@gelato-api-ui/core/e-commerce/e-product-variant-update-request';
import { ETaskResponse } from '@api-ui-app/src/app/e-commerce-framed-posters-upgrade/types/e-task-response';
import { ETaskStatus } from '@api-ui-app/src/app/e-commerce-framed-posters-upgrade/types/e-task-status.enum';
import { EResponseTaskParameters } from '@api-ui-app/src/app/e-commerce-framed-posters-upgrade/types/e-task-parameters';

@Injectable({
  providedIn: 'root',
})
export class PriceNavigatorAutoSaveService {
  getProductVariantsPricesToSaveFromDraft(
    draftPrices: PriceNavigatorDraftPrices[],
    setPendingPriceToNull: boolean = false,
  ): Partial<EProductVariantUpdateRequest>[] {
    return draftPrices.map(draftItem => ({
      id: draftItem.variantId,
      currency: draftItem.storeCurrency,
      ...(draftItem.newRetailPriceInStoreCurrency
        ? { pendingPrice: setPendingPriceToNull ? null : draftItem.newRetailPriceInStoreCurrency }
        : null),
      ...(isNotNil(draftItem.newCompareAtPriceInStoreCurrency)
        ? { pendingCompareAtPrice: setPendingPriceToNull ? null : draftItem.newCompareAtPriceInStoreCurrency }
        : null),
    }));
  }

  getDraftPricesFromTasks(
    draftPrices: PriceNavigatorDraftPrices[],
    tasks: ETaskResponse[],
  ): PriceNavigatorDraftPrices[] {
    const filterTasksByCompletion = tasks?.filter(task =>
      [ETaskStatus.FINISHED, ETaskStatus.FAILED].includes(task.status),
    );
    const productIdsFromCompletedTasks: string[] = flatten(
      filterTasksByCompletion?.map(task => {
        const parameters: EResponseTaskParameters = JSON.parse(task.parameters);
        return parameters.productIds;
      }),
    );

    return draftPrices?.filter(draftPrice => productIdsFromCompletedTasks?.includes(draftPrice.productId));
  }
}
